import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { eq, and } from "drizzle-orm";
import z from "zod";
import { auth } from "~/lib/better-auth/auth";
import { db } from "~/db";
import { locationsToUsers, user } from "~/db/schema";

const checkLocationPreviewAuthorizationSchema = z.object({
  locationId: z.number(),
  previewPlan: z.enum(["superior", "premium", "basic"]),
});

export const checkLocationPreviewAuthorization = createServerFn({
  method: "GET",
})
  .inputValidator(checkLocationPreviewAuthorizationSchema)
  .handler(async (ctx) => {
    const { locationId, previewPlan } = ctx.data;
    const request = getRequest();

    if (!request?.headers) {
      return null;
    }

    const userSession = await auth.api.getSession({ headers: request.headers });

    if (!userSession?.user) {
      return null;
    }

    // Super admins can preview any location with any plan
    const [dbUser] = await db
      .select({ isSuperAdmin: user.isSuperAdmin })
      .from(user)
      .where(eq(user.id, userSession.user.id))
      .limit(1);
    if (dbUser?.isSuperAdmin === true) {
      return previewPlan;
    }

    // Check if user owns this location
    const userLocation = await db
      .select()
      .from(locationsToUsers)
      .where(
        and(
          eq(locationsToUsers.locationId, locationId),
          eq(locationsToUsers.userId, userSession.user.id)
        )
      )
      .limit(1)
      .execute();

    if (userLocation.length > 0) {
      return previewPlan;
    }

    return null;
  });

